import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_PLACE_PREDICTIONS } from "../../../../queries/queries/get-place-predictions.js";
import fromQueryPlacePredictionsToPlacePredictions from "../../adapters/hooks/api/adapters/fromQueryPlacePredictionsToPlacePredictions.js";
const usePlacePredictions = (options) => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(
    GET_PLACE_PREDICTIONS,
    {
      ...options,
      context: {
        ...options?.context,
        forwardHeaders: {
          ...options?.context?.forwardHeaders,
          "Accept-Language": locale
        }
      }
    }
  );
  const data = React.useMemo(
    () => fromQueryPlacePredictionsToPlacePredictions(queryState.data?.placePredictions),
    [queryState.data]
  );
  return React.useMemo(
    () => [
      query,
      {
        ...queryState,
        data
      }
    ],
    [data, queryState, query]
  );
};
export {
  usePlacePredictions as default
};
//# sourceMappingURL=use-place-predictions.js.map
